/* assets/component-card-scent.js */

// Funkcja aktualizująca aktywną kropkę na podstawie scrolla
function updateActiveDot(container) {
  const dotsContainer = container.parentElement.querySelector('.card-scent-dots');
  if (!dotsContainer) return;

  const slideWidth = container.offsetWidth;
  const scrollPos = container.scrollLeft;
  
  // Obliczamy index: (pozycja scrolla + połowa szerokości) / szerokość slajdu
  // Dodanie połowy szerokości sprawia, że kropka zmienia się w momencie przekroczenia 50% przewinięcia
  const activeIndex = Math.round(scrollPos / slideWidth);
  
  const dots = dotsContainer.querySelectorAll('.card-scent-dot');
  
  dots.forEach((dot, index) => {
    if (index === activeIndex) {
      dot.classList.add('active');
    } else {
      dot.classList.remove('active');
    }
  });
}

// 1. Obsługa kliknięcia w kropkę (Event Delegation)
document.addEventListener('click', function(e) {
  if (!e.target.classList.contains('card-scent-dot')) return;

  const dot = e.target;
  const index = parseInt(dot.getAttribute('data-index'));
  const wrapper = dot.closest('.card-scent-box');
  const container = wrapper.querySelector('.card-scent-track');
  
  if (container) {
    const slideWidth = container.offsetWidth;
    container.scrollTo({
      left: slideWidth * index,
      behavior: 'smooth'
    });
  }
});

// 2. Obsługa scrollowania (Event Delegation - Capture phase)
// Używamy 'useCapture' (true) żeby łapać scroll eventy, które nie bąbelkują
document.addEventListener('scroll', function(e) {
  if (e.target.classList && e.target.classList.contains('card-scent-track')) {
    // Debounce (prosty) - żeby nie odpalać obliczeń zbyt często
    if (e.target.timeout) clearTimeout(e.target.timeout);
    e.target.timeout = setTimeout(() => {
       updateActiveDot(e.target);
    }, 50);
  }
}, true);